import { withI18n } from 'react-i18next';
import MobileSubcategorySelect from './MobileSubcategoriesSelect';

export const pureComponent = MobileSubcategorySelect;
export default withI18n()(MobileSubcategorySelect);
